import {
	CrossNavigationBannerAction,
	CrossNavigationBannerIcon,
	CrossNavigationBannerLink,
	CrossNavigationBannerText
} from "components/Common/CrossNavigationBanner/CrossNavigationBanner.styles.ts";

interface CrossNavigationBannerProps {
	className?: string;
	to: string;
	prefixText: string;
	actionText: string;
	dataTestId?: string;
}

const CrossNavigationBanner = ({ className, to, prefixText, actionText, dataTestId }: CrossNavigationBannerProps) => {
	return (
		<CrossNavigationBannerLink
			to={to}
			className={className}
			data-testid={dataTestId}
		>
			<CrossNavigationBannerIcon />
			<CrossNavigationBannerText>
				{prefixText} <CrossNavigationBannerAction>{actionText}</CrossNavigationBannerAction>.
			</CrossNavigationBannerText>
		</CrossNavigationBannerLink>
	);
};

export default CrossNavigationBanner;
